import { ClientResetPasswordEmailRequest } from 'vopay';
import { useEffect } from 'react';
import axios from 'axios';
import vopayApi from '@/services/api.config';
const { api } = vopayApi;

export default function useResetPassword() {
  const source = axios.CancelToken.source();

  useEffect(() => {
    return () => {
      source.cancel();
    };
  }, []);

  const resetPassword = async (request: ClientResetPasswordEmailRequest) => {
    try {
      const res = await api.postClientResetPasswordEmail(request, source);
      if (!res.Success) throw new Error(res.ErrorMessage);
      return res;
    } catch (err) {
      console.error(err);
      throw err;
    }
  };

  return {
    resetPassword,
  };
}
